import { registerComponent } from '@gig/magic-common';
import LoaderComponent from './loader.vue.js';

var Loader = registerComponent(LoaderComponent);

export { Loader };
